import AgiliteUtils from 'agilite-utils'

import MemoryStore from '../utils/memory-store'
import { cleanupObject, isDuplicateEntry, updateArrayDataFromSave } from '../utils/utilities'
import { postData } from '../core/core-utils'
import { formatRecord } from './team-users-utils'
import Enums from '../utils/enums'

/*
  ENUMS
*/
export const actions = {
  RESET_STATE: 'RESET_STATE_TEAM_USERS',
  CREATE_PROFILE: 'CREATE_PROFILE_TEAM_USERS',
  SAVE_PROFILE: 'SAVE_PROFILE_TEAM_USERS',
  CANCEL_PROFILE: 'CANCEL_PROFILE_TEAM_USERS',
  EDIT_PROFILE: 'EDIT_PROFILE_TEAM_USERS',
  DELETE_PROFILE: 'DELETE_PROFILE_TEAM_USERS',
  FETCH_ALL_DATA: 'FETCH_ALL_DATA_TEAM_USERS',
  SET_SEARCH_FILTER: 'SET_SEARCH_FILTER_TEAM_USERS',
  UPDATE_DATA: 'UPDATE_DATA_TEAM_USERS'
}

/*
  DISPATCH FUNCTIONS
*/
export const setSearchFilter = (value) => {
  return {
    type: actions.SET_SEARCH_FILTER,
    value
  }
}

export const updateData = (data) => {
  return {
    type: actions.UPDATE_DATA,
    data
  }
}

export const saveProfile = (appId, recordId, state, callback) => {
  return async (dispatch) => {
    const entry = MemoryStore.activeEntries[recordId]
    const headers = {}

    let result = true
    let reqType = ''
    let tempArray = state.data.concat()
    let errMsg = null

    // Cleanup and Trim
    cleanupObject(entry.data)
    await AgiliteUtils.trimObjectValues(entry.data)

    // Validation
    if (entry.firstName === '') {
      errMsg = 'Please provide a First Name'
      return callback(errMsg)
    }

    if (entry.lastName === '') {
      errMsg = 'Please provide a Last Name'
      return callback(errMsg)
    }

    if (entry.email === '') {
      errMsg = 'Please provide an Email'
      return callback(errMsg)
    }

    // Duplicate Check
    result = isDuplicateEntry(entry, 'email', tempArray, false)

    if (!result) {
      errMsg = `Email '${entry.email}' has already been defined`
      return callback(errMsg)
    }

    // Finalize

    // Post Data to Agilit-e
    tempArray = formatRecord(entry, tempArray)
    reqType = entry.custom.action === 'create' ? 'post' : 'put'

    // Create Headers Object
    headers['record-id'] = recordId

    // Dispatch New Array
    dispatch({
      type: actions.UPDATE_DATA,
      data: tempArray
    })

    postData(appId, reqType, entry, headers)
      .then((response) => {
        callback(null)

        entry.custom.action = ''
        entry.custom.isSavedDoc = true
        entry.key = response.data._id
        entry._id = response.data._id
        entry.isActiveDescription = response.data.teamRights.isActive ? 'Yes' : 'No'
        entry.teamRights.status = response.data.teamRights.status
        entry.teamRights.role = response.data.teamRights.role

        tempArray = updateArrayDataFromSave(entry, tempArray)

        dispatch({
          type: actions.UPDATE_DATA,
          data: tempArray
        })
      })
      .catch((error) => {
        console.log(error)

        if (error.response) {
          callback(error.response.data.errorMessage)
        } else {
          callback(Enums.MESSAGES.UNKNOWN_ERROR)
        }
      })
  }
}
